import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faUserSlash } from "@fortawesome/free-solid-svg-icons";

/**
 * Empty state component for search results
 *
 * Shows appropriate message when:
 * - No search query entered yet
 * - No results found for query
 */
const SearchEmptyState = ({ query = "", compact = false }) => {
  const hasQuery = query && query.trim().length >= 2;

  if (!hasQuery) {
    // No search query yet
    return (
      <div className={`text-center ${compact ? "py-6" : "py-12"}`}>
        <FontAwesomeIcon
          icon={faSearch}
          className={`text-medium-grey mb-3 ${compact ? "text-2xl" : "text-4xl"}`}
        />
        <div
          className={`text-medium-grey ${compact ? "text-sm" : "text-base"}`}
        >
          Enter at least 2 characters to search for users
        </div>
      </div>
    );
  }

  // No results found
  return (
    <div className={`text-center ${compact ? "py-6" : "py-12"}`}>
      <FontAwesomeIcon
        icon={faUserSlash}
        className={`text-medium-grey mb-3 ${compact ? "text-2xl" : "text-4xl"}`}
      />
      <div
        className={`font-medium text-dark-grey mb-2 ${compact ? "text-sm" : "text-base"}`}
      >
        No users found
      </div>
      <div className={`text-medium-grey ${compact ? "text-xs" : "text-sm"}`}>
        No users match "{query}"
      </div>
      <div
        className={`text-medium-grey mt-2 ${compact ? "text-xs" : "text-sm"}`}
      >
        Try a different search term
      </div>
    </div>
  );
};

SearchEmptyState.propTypes = {
  query: PropTypes.string,
  compact: PropTypes.bool,
};

export default SearchEmptyState;
